<button
  pButton
  [class]="buttonClass"
  [ngClass]="buttonNgClass"
  [disabled]="disabled"
  [icon]="icon"
  [label]="label | translate"
  (click)="open($event)"
></button>
<p-sidebar
  [closeOnEscape]="closeOnEscape"
  [(visible)]="visible"
  [styleClass]="styleClass"
  [modal]="modal"
  [blockScroll]="blockScroll"
  [closeIcon]="closeIcon"
  [position]="position"
  [fullScreen]="fullscreen"
  [dismissible]="dismissible"
  [showCloseIcon]="showCloseIcon"
  appendTo="body"
  (onHide)="onDismiss()"
>
  <ng-container *ngIf="visible">
    <ng-container *ngTemplateOutlet="toggle"></ng-container>
  </ng-container>
</p-sidebar>
